import { __awaiter } from "tslib";
import Vue from 'vue';
import { ActivePopupTypes } from '@/store/modules/popup/types';
import { mapGetters } from 'vuex';
import { StepByStepGlossary } from '@/constants/services';
import { YubikeyAuthMixin } from '@/mixins/YubikeyAuthMixin';
export default Vue.extend({
    name: 'apiKeysAhead',
    mixins: [YubikeyAuthMixin],
    props: {
        searchField: {
            type: String,
            required: true
        },
        haveSelected: {
            type: Boolean,
            required: true
        },
        selectedItems: {
            type: Array,
            required: true
        }
    },
    data: () => ({
        searchPhrase: ''
    }),
    computed: Object.assign(Object.assign({}, mapGetters('user', ['getUserData'])), { canCreateKey() {
            return this.getUserData.permissions.binance.apiKeys.create;
        } }),
    methods: {
        openBuddyDeleteModal() {
            const vm = this;
            this.$store.dispatch('popupModule/openPopup', {
                type: ActivePopupTypes.action,
                letDefaultClose: true,
                title: this.$t('popups.titles.deleteKey'),
                slot: {
                    name: 'buddyDeletePopupChunk',
                    on: {
                        onDelete() {
                            vm.handleDelete2FA();
                        }
                    }
                }
            });
        },
        handleDeleteClick() {
            if (this.selectedItems[0].itBuddyKey) {
                this.openBuddyDeleteModal();
            }
            else {
                this.handleDelete2FA();
            }
        },
        handleDelete2FA() {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                const selectedItem = vm.selectedItems[0];
                const confirmationType = vm.getUserData.confirmation;
                if (confirmationType === 'yubikey') {
                    const yubikeyDeleteItem = () => {
                        this.YubikeyAuth(StepByStepGlossary.deleteApiKey, StepByStepGlossary.deleteApiKey, (authResponse, sessionId) => __awaiter(this, void 0, void 0, function* () {
                            var _a;
                            if (!authResponse.success) {
                                this.$store.commit('popupModule/setClosed');
                                this.$store.dispatch('alertsBus/openAlert', {
                                    title: vm.$t('apiKeysPage.alerts.titles.error'),
                                    type: 'error',
                                    autoDelete: true,
                                    content: (_a = authResponse.errors.join('\n')) !== null && _a !== void 0 ? _a : vm.$t('apiKeysPage.alerts.content.failedExecuteOperation')
                                });
                                return;
                            }
                            this.$emit('onDelete', {
                                session_id: sessionId,
                                id: selectedItem.id
                            });
                        }), null, yubikeyDeleteItem);
                    };
                    yubikeyDeleteItem();
                    return;
                }
                const response = yield vm.services.mainService.confirmSession({ sessionId: StepByStepGlossary.deleteApiKey });
                if (!response.success) {
                    vm.$store.commit('popupModule/setClosed');
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: 'Ошибка',
                        type: 'error',
                        autoDelete: true,
                        content: vm.$t('apiKeysPage.alerts.content.failedExecuteOperation')
                    });
                    return;
                }
                const sessionId = response.data.session_id;
                const confirmations = response.data.confirmations;
                const smsVerify = vm.getUserData.confirmation === 'sms';
                vm.$store.dispatch('popupModule/openPopup', {
                    type: ActivePopupTypes.action,
                    letDefaultClose: true,
                    title: vm.$t('apiKeysPage.popups.titles.deleteKey', { name: selectedItem.name }),
                    content: smsVerify ? vm.$t('apiKeysPage.popups.content.confirmViaSMS') : vm.$t('apiKeysPage.popups.content.confirmViaGA'),
                    slot: {
                        name: smsVerify ? 'commonConfirmSMSPopupChunk' : 'commonConfirmGAPopupChunk',
                        data: {
                            isLoading: false,
                            codes: confirmations,
                            sessionId,
                            responseErrors: []
                        },
                        on: {
                            onSubmit(payload) {
                                return __awaiter(this, void 0, void 0, function* () {
                                    vm.$store.commit('popupModule/setSlotData', { isLoading: true });
                                    const validateSessionResponse = yield vm.services.mainService.validateSession({ payload: { [confirmationType]: payload[`code_${confirmationType}`] }, sessionId });
                                    if (!validateSessionResponse.success) {
                                        vm.$store.commit('popupModule/setSlotData', { responseErrors: validateSessionResponse.data.errors, isLoading: false });
                                        return;
                                    }
                                    vm.$emit('onDelete', {
                                        session_id: sessionId,
                                        id: selectedItem.id,
                                        code: smsVerify ? payload.code_sms : payload.code_ga
                                    });
                                });
                            },
                            onCancel() {
                                vm.$store.commit('popupModule/setClosed');
                            }
                        }
                    }
                });
            });
        }
    }
});
